import { BrowserStorageService } from "@/browser-storage";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

export function useCachedState<T>(storage: BrowserStorageService<T | null>, key?: string):
  [T | null, Dispatch<SetStateAction<T | null>>] {
  const [state, setState] = useState<T | null>(null);

  useEffect(() => {
    setState(storage.getItem(key));
  }, [storage, key]);

  useEffect(() => {
    storage.setItem(state, key);
  }, [storage, state, key]);

  return [state, setState];
}
